module.exports = __webpack_public_path__ + "static/media/map_pin.51923b88.svg";